import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

import logo from '../assets/logoletras.png';
import buscadorIcon from '../assets/lupita.png';
import carritoIcon from '../assets/carrito.png';
import notificacionesIcon from '../assets/notificaciones.png';
import favoritoIcon from '../assets/favorito.png';
import usuarioIcon from '../assets/usuario.png';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${searchQuery.trim()}`);
      setSearchQuery('');
    }
  };

  return (
    <header className="navbar-container">
      <div className="navbar-top">
        <Link to="/">
          <img src={logo} alt="Logo Tech Market B.A" className="navbar-logo" />
        </Link>

        <form className="search-container" onSubmit={handleSearchSubmit}>
          <input
            type="text"
            placeholder="Click aquí para buscar..."
            className="search-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit" className="search-button">
            <img src={buscadorIcon} alt="Buscar" />
          </button>
        </form>

        <div className="navbar-icons">
          <Link to="/cart"><img src={carritoIcon} alt="Carrito" className="nav-icon" /></Link>
          <Link to="/notifications"><img src={notificacionesIcon} alt="Notificaciones" className="nav-icon" /></Link>
          <Link to="/favorites"><img src={favoritoIcon} alt="Favoritos" className="nav-icon" /></Link>
          
          {user ? (
            <Link to={`/user/${user.id}`} className="nav-profile-link">
              <img 
                src={user.avatar || usuarioIcon} 
                alt="Mi Perfil" 
                className="navbar-profile-pic" 
              />
            </Link>
          ) : (
            <Link to="/login" className="nav-icon-link">
              <img src={usuarioIcon} alt="Ingresar" className="nav-icon" />
            </Link>
          )}
        </div>
      </div>

      <nav className="navbar-bottom">
        <div className="nav-category-links">
          {/* --- CAMBIO: AHORA LOS LINKS EJECUTAN UNA BÚSQUEDA --- */}
          <Link to="/search?q=PC" className="nav-link">PC</Link>
          <Link to="/search?q=Laptop" className="nav-link">LAPTOP</Link>
          <Link to="/search?q=CPU" className="nav-link">CPU</Link>
          <Link to="/search?q=GPU" className="nav-link">GPU</Link>
          <Link to="/search?q=Gabinetes" className="nav-link">GABINETES</Link>
          <Link to="/search?q=Otros" className="nav-link">OTROS</Link>
        </div>
        
        <div className="nav-user-actions">
          {user ? (
            <>
              <Link to="/purchases" className="nav-link">Mis compras</Link>
              <button onClick={handleLogout} className="nav-link-button">Cerrar Sesión</button>
            </>
          ) : (
            <>
              <Link to="/signup" className="nav-link">Crea una cuenta</Link>
              <Link to="/login" className="nav-link">Ingresa</Link>
            </>
          )}
          <Link to="/help" className="nav-link">Ayuda</Link>
        </div>
      </nav>
    </header>
  );
}